import axios from "axios";

const cleanParam = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text === "null" || text === "undefined") return "";
  return text;
};

export const getAlterationReportStatuses = async () => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/list-alteration-report-statuses`,
      config
    );
    return data?.data?.result || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const downloadAlterationReport = async (inputs = {}) => {
  const urlParams = new URLSearchParams();
  const from = cleanParam(inputs.from);
  const to = cleanParam(inputs.to);
  const year = cleanParam(inputs.year);
  const month = cleanParam(inputs.month);
  const factoryId = cleanParam(inputs.factory_id || inputs.factory?.id);
  const factoryName = cleanParam(
    inputs.factory_name ||
      inputs.order_item_factory_name ||
      inputs.factory?.factory_name
  );
  const portNoAndName = cleanParam(
    inputs.port_no_and_name || inputs.order_port_no_and_name
  );
  const orderItemStatus = cleanParam(inputs.order_item_status);
  const salesmanId = cleanParam(
    inputs.salesman_id || inputs.sales_person?.id || inputs.sales_person_id
  );
  const salesmanName = cleanParam(
    inputs.salesman_name ||
      inputs.sales_person?.full_name ||
      inputs.sales_person
  );

  if (from) urlParams.set("from", from);
  if (to) urlParams.set("to", to);
  if (year) urlParams.set("year", year);
  if (month) urlParams.set("month", month);
  if (factoryId) urlParams.set("factory_id", factoryId);
  if (factoryName) urlParams.set("factory_name", factoryName);
  if (portNoAndName) urlParams.set("port_no_and_name", portNoAndName);
  if (orderItemStatus) urlParams.set("order_item_status", orderItemStatus);
  if (salesmanId) urlParams.set("salesman_id", salesmanId);
  if (salesmanName) urlParams.set("salesman_name", salesmanName);

  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const query = urlParams.toString();
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/list-alteration-report-excel${
        query ? `?${query}` : ""
      }`,
      config
    );
    const result = data?.data?.result;
    if (typeof result === "string" && /^https?:\/\//i.test(result.trim())) {
      return result.trim();
    }
    return null;
  } catch (error) {
    console.log(error);
    if (error?.response?.data?.message) {
      throw error;
    }
    return null;
  }
};
